export default "__VITE_ASSET__e026a48a__"